import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  useMediaQuery,
  useTheme,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const AddPackagesDialog = ({
  addPackagesOpen,
  setAddPackagesOpen,
  packageCount,
  setPackageCount,
  handleAddPackages
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (addPackagesOpen) {
      setPackageCount('');
    }
  }, [addPackagesOpen, setPackageCount]);

  const handleChange = (e) => {
    const val = e.target.value.trim();
    if (/^\d*$/.test(val)) {
      setPackageCount(val === '' ? '' : parseInt(val));
    }
  };

  const isInvalid = packageCount === '' || packageCount <= 0;

  return (
    <Dialog
      open={addPackagesOpen}
      onClose={() => setAddPackagesOpen(false)}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 3,
          px: 2,
          py: 1.5,
          backgroundColor: theme.palette.background.paper,
        }
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, textAlign: 'center' }}>
        {t('Add Packages')}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" mb={1}>
          {t('Enter number of packages')}
        </Typography>
        <TextField
          type="number"
          fullWidth
          variant="outlined"
          label={t('Number of packages')}
          placeholder={t('e.g. 5')}
          value={packageCount}
          onChange={(e) => {
            const value = Number(e.target.value);
            if (value > 100) {
              setPackageCount(100);
            } else {
              setPackageCount(value);
            }
          }}
          error={isInvalid}
          helperText={
            isInvalid
              ? t('Packages must be greater than 0')
              : ``
          }
          inputProps={{ min: 1, max: 100 }}
        />
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
        <Button
          onClick={() => setAddPackagesOpen(false)}
          variant="outlined"
          color="inherit"
          size={isMobile ? 'small' : 'medium'}
        >
          {t('Cancel')}
        </Button>

        <Button
          onClick={handleAddPackages}
          variant="contained"
          color="primary"
          size={isMobile ? 'small' : 'medium'}
          disabled={isInvalid}
        >
          {t('Add')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPackagesDialog;
